module.exports = __webpack_public_path__ + "static/img/n1.3cf6e5e5.jpg";